import { type DocumentInfo, DocumentItem } from './DocumentItem';
import { joinNames } from '@n2-common/ui/helpers';
import style from './style.module.scss';
import { type Selector } from '@n2-common/lib/useFootnotes';
import { useMemo } from 'react';

export function Uploads({ documents, refreshing, deleteDocumentHandler, footnoteSelector }: UploadsProps) {
    const documentList = useMemo(
        () =>
            documents.map((elm, i) => (
                <DocumentItem key={i} info={elm} deleteDocumentHandler={deleteDocumentHandler} selectFootnote={footnoteSelector} />
            )),
        [deleteDocumentHandler, documents, footnoteSelector]
    );
    return documentList.length ? <div className={joinNames(style.documentContainer, refreshing ? style.busy : undefined)}>{documentList}</div> : null;
}

type UploadsProps = {
    documents: DocumentInfo[];
    refreshing: boolean;
    deleteDocumentHandler: (documentId: string) => void;
    footnoteSelector: Selector<DocumentInfo>;
};
